import { render, staticRenderFns } from "./CPPageWrapper.vue?vue&type=template&id=7c94ae1e&scoped=true&"
import script from "./CPPageWrapper.vue?vue&type=script&lang=ts&"
export * from "./CPPageWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./CPPageWrapper.vue?vue&type=style&index=0&id=7c94ae1e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c94ae1e",
  null
  
)

export default component.exports